import { AssessmentCollectionLeftMenuList } from "../utils/constants";
import { RenderNavItem } from "../components/RenderNavItem";
import { LeftSocialMediaIconUI } from "../components/LeftSocialMediaIconUI";
import { useTranslation } from "react-i18next";

const ListOfTreasuryCountersForcollectionOfPropertyTax = [
  {
    location: "CMO Bldg.",
    officeAddress: "5, S.N. Banerjee Road, Kolkata-700013",
  },
  {
    location: "Cossipore",
    officeAddress: "10, B.T.Road, Kolkata-700002",
  },
  {
    location: "College Street",
    officeAddress: "22, Surya Sen Street, Kolkata-700012",
  },
  {
    location: "New Alipore Market Complex",
    officeAddress: "Beside Durgapur Bridge",
  },
  {
    location: "Gachtala",
    officeAddress: "180, N.S.C. Bose Road, Kolkata-700040",
  },
  {
    location: "Prince Anwar Shah Road",
    officeAddress: "28. P.A.Shah Road, Kolkata-700033",
  },
  {
    location: "Santoshpur Avenue",
    officeAddress: "K.M.C. Super Market, Kolkata-700075",
  },
  {
    location: "Garden Reach",
    officeAddress: "E/3, Circular Garden Reach Road, Kolkata- 700024",
  },
  {
    location: "Joka -II",
    officeAddress: "Diamond Park, Kolkata - 104",
  },
];

const ListOfEKolkataCitizenServiceCentres = [
  {
    location: "K.N.Sen Road ( Kasba )",
    officeAddress: "28A K.N.Sen Road, Kasba, 1st Floor, Kolkata - 700042",
  },
  {
    location: "Maniktala-Kankurgachi VIP Market",
    officeAddress: "P-187 C.I.T. Road, 2nd Floor, Kolkata - 700054",
  },
  {
    location: "Behala",
    officeAddress: "516 Diamond Harbour Road , Kolkata-700034",
  },
  {
    location: "Alipore",
    officeAddress: "11, Belvedere Road,Kolkata-700027",
  },
  {
    location: "Gariahat",
    officeAddress: "212, Rashbehari Avenue, Kolkata - 700019, Borough - 8",
  },
  {
    location: "Hatibagan",
    officeAddress: "79, Bidhan Sarani, Kolkata - 700006, Borough -2",
  },
  {
    location: "Baghajatin",
    officeAddress:
      "Baghajatin Market Complex, Unit-2, Raja S. C. Mullick Road,Kolkata-700092 (beside Raktakamal Club)",
  },
  {
    location: "Bagbazar",
    officeAddress: "56/1 Raja Rajballabh Street, Kolkata – 700003, Borough-1",
  },
  {
    location: "Sakher bazar Super Market Basement",
    officeAddress: "42,D.H Road Kolkata - 700 008 ,Borough -XIV",
  },
  {
    location: "Rasbehari Avenue",
    officeAddress: "104, Rasbehari Avenue, Kol-700029, Borough - VIII",
  },
];

export const ListOfCounters = () => {
  const { t } = useTranslation();

  return (
    <>
      <section id="hero" className="hero hero2">
        <LeftSocialMediaIconUI />

        <div className="carousel-item active">
          <img src="assets/img/inner-bg2.png" className="img-fluid" alt="alt" />
          <div className="container">
            <div className="section-main-heading2">
              <h4 className="fontSizeClass"> </h4>
            </div>
          </div>
        </div>
      </section>
      {/* End Slider */}
      <section className="section inner-pad1">
        <div className="container">
          <div className="row">
            <div className="col-lg-3">
              <div className="site-menu">
                <nav className="sidebar card py-2">
                  <ul className="nav flex-column" id="nav_accordion">
                    {AssessmentCollectionLeftMenuList.map((item, index) => (
                      <RenderNavItem item={item} index={index} t={t} />
                    ))}
                  </ul>
                </nav>
              </div>
            </div>
            <div className="col-lg-9">
              <div className="container">
                <div className="row">
                  <div className="inner-title2">
                    <h3 className="fontSizeClass">
                      List of Treasury Counters for collection of Property Tax
                    </h3>
                  </div>
                  <div className="mayor-table">
                    <table className="table table-bordered basic_static_table">
                      <thead>
                        <tr className="table-warning table-bor-2">
                          <th
                            className="bd-wid"
                            scope="col"
                            style={{
                              position: "sticky",
                              top: 0,
                              background: "#fff",
                              zIndex: 10,
                            }}
                          >
                            {t("Sl.No")}.
                          </th>
                          <th
                            scope="col"
                            style={{
                              position: "sticky",
                              top: 0,
                              background: "#fff",
                              zIndex: 10,
                            }}
                          >
                            Location
                          </th>
                          <th
                            scope="col"
                            style={{
                              position: "sticky",
                              top: 0,
                              background: "#fff",
                              zIndex: 10,
                            }}
                          >
                            Office Address
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {ListOfTreasuryCountersForcollectionOfPropertyTax.map(
                          (item, index) => (
                            <tr key={index}>
                              <td> {index + 1} </td>
                              <td>{item.location}</td>
                              <td>{item.officeAddress}</td>
                            </tr>
                          )
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
                <div className="row">
                  <div className="inner-title2">
                    <h3 className="fontSizeClass">
                      List of e-Kolkata Citizen Service Centres
                    </h3>
                  </div>
                  <div className="mayor-table">
                    <table className="table table-bordered basic_static_table">
                      <thead>
                        <tr className="table-warning table-bor-2">
                          <th
                            className="bd-wid"
                            scope="col"
                            style={{
                              position: "sticky",
                              top: 0,
                              background: "#fff",
                              zIndex: 10,
                            }}
                          >
                            {t("Sl.No")}.
                          </th>
                          <th
                            scope="col"
                            style={{
                              position: "sticky",
                              top: 0,
                              background: "#fff",
                              zIndex: 10,
                            }}
                          >
                            Location
                          </th>
                          <th
                            scope="col"
                            style={{
                              position: "sticky",
                              top: 0,
                              background: "#fff",
                              zIndex: 10,
                            }}
                          >
                            Office Address
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {ListOfEKolkataCitizenServiceCentres.map(
                          (item, index) => (
                            <tr key={index}>
                              <td> {index + 1} </td>
                              <td>{item.location}</td>
                              <td>{item.officeAddress}</td>
                            </tr>
                          )
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
                <div className="row">
                  <div className="mayor-table" style={{ height: "auto" }}>
                    <table className="table table-bordered basic_static_table">
                      <thead>
                        <tr className="table-warning table-bor-2">
                          <th scope="col"> Mode of payment </th>
                          <th scope="col"> Hours of payment</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>
                            No Cheque will be accepted. Cash payment upto
                            Rs.25,000/-. Above Rs.25,000/- payment by Draft /
                            Pay Order is accepted.
                          </td>
                          <td>
                            Weekdays-11-00 a.m. to 3-00 p.m. <br />{" "}
                            Saturday-11-00 a.m. to 1-00 p.m.
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};
